import React from "react";
import { Box, Typography, Link as ExternalLink, SvgIconProps } from "@mui/material";
import { PhoneIcon } from "../../icons/Phone";
import { useIntl } from "gatsby-plugin-intl";

type PhoneContactProps = {
  description: React.ReactNode;
  phoneID: string;
  slotProps?: {
    icon?: {
      sx?: Required<SvgIconProps>["sx"];
    };
  }
  onClick?: () => void;
};

function PhoneContact({ description, phoneID, slotProps, onClick }: PhoneContactProps) {
  const { formatMessage } = useIntl();
  const phone = formatMessage({ id: phoneID });
  return (
    <ExternalLink color="inherit" href={`tel:${phone}`} onClick={onClick}>
      <Box
        sx={{
          display: "inline-flex",
          alignItems: "center",
        }}
      >
        <PhoneIcon
          sx={{
            fill: "white",
            fontSize: "2.5rem",
            ...slotProps?.icon?.sx,
          }}
        />
        <Box
          px={2}
          sx={{
            textWrap: "nowrap",
          }}
        >
          <Typography variant="h4" component="p">{phone}</Typography>
          <Typography variant="body1" textAlign="left">
            {description}
          </Typography>
        </Box>
      </Box>
    </ExternalLink>
  );
}

export { PhoneContact };
